<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],    
 data() {
  return { 
   title: "CRM",
   text: "CRM",
   toast: useToast(),
   total: 0,
   data: [],
   categories: [],
   current_page: 1,
   page_size: 25,
   searchText: '', 
   filterCategory: '',
   columns: [
    { title: 'S.No', dataIndex: 'SNo', key: 'SNo' },
    { title: 'Question', dataIndex: 'Question', key: 'Question' },
    { title: 'Category', dataIndex: 'Category', key: 'Category' },
    { title: 'Priority', dataIndex: 'Priority', key: 'Priority' },
    { title: 'Status', dataIndex: 'Status', key: 'Status' },
    { title: 'Actions', key: 'action' },
   ],
   rowSelection: null,
  };
 },

 computed: {
  text1(){
   return `FAQs (${this.total})`; 
  },
    hasActiveFilter(){
   return !!this.filterCategory || !!this.searchText;
  },
  filteredData() {
   let result = this.data;
   if (this.filterCategory) {
    result = result.filter(item => item.knowledge_base_category_id === this.filterCategory);
   }
   if (this.searchText) {
    const search = this.searchText.toLowerCase();
    result = result.filter(item => item.question?.toLowerCase().includes(search));
   }
   return result;
  },
 },

 mounted() {
  this.knowledgeBases();
  this.loadCategories();
 }, 

 methods: {
  async knowledgeBases(){
   this.setLoading(true);
   try{
    const response = await axios.get(`/knowledge-bases`);
    this.data = response.data.data.data;
    this.total = response.data.data.total;
   }catch(error){
    this.toast.error(error.message);
   }finally{
    this.setLoading(false);
   }
  },
  async loadCategories(){
   try{
    const response = await axios.get(`/knowledge-base-categories`);
    this.categories = response.data.data.data;
   }catch(error){
    this.toast.error(error.message);
   }
  },
  categoryName(id){
   const cat = this.categories.find(c => c.id === id);
   return cat ? cat.name : '-';
  },
  handleTableChange(pagination){
   this.current_page = pagination.current;
   this.page_size = pagination.pageSize;
  },
  clearFilter(){
   this.filterCategory = '';
   this.searchText = '';
  }
 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<div class="page-wrapper">
<div class="content">
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<div class="mb-2">
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#knowledge_base_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.knowledgeBaseModal.knowledgeBase();"><i class="ti ti-circle-plus me-2"></i>Add New</a>
</div>
</div>
</div>

<div class="card">
<div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
<h5>FAQs List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 gap-2">
<div style="min-width: 180px;">
  <vue-select
    v-model="filterCategory"
    :options="categories"
    label="name"
    :reduce="c => c.id"
    placeholder="All Categories"
    :clearable="true"
  ></vue-select>
</div>
<div class="">
  <a-input v-model:value="searchText" placeholder="Search question..." allow-clear style="width: 250px;"/>
</div>
<a v-if="hasActiveFilter" href="javascript:void(0);" class="btn btn-icon btn-outline-danger" title="Clear Filters" @click="clearFilter">
  <i class="ti ti-filter-x"></i>
</a>
</div>
</div>
<div class="card-body p-0">
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection" :pagination="{ pageSize: page_size, current: current_page }" @change="handleTableChange">
  <template #bodyCell="{ column, record, index }">
    <template v-if="column.key === 'SNo'"> {{ index + 1 + (current_page - 1) * page_size }}. </template>   
    <template v-if="column.key === 'Question'">
      <h6 class="fs-14 fw-medium">{{ record.question }}</h6>
    </template>
    <template v-if="column.key === 'Category'">
      {{ categoryName(record.knowledge_base_category_id) }}
    </template>
    <template v-if="column.key === 'Priority'">
      {{ record.priority }}
    </template>
    <template v-if="column.key === 'Status'">
      <span class="badge" :class="record.is_active ? 'bg-success' : 'bg-danger'">
        {{ record.is_active ? 'Active' : 'Inactive' }}
      </span>
    </template>
    <template v-if="column.key === 'action'">
      <div class="action-icon d-inline-flex">
        <a href="javascript:void(0);" class="me-2" data-bs-toggle="modal" data-bs-target="#knowledge_base_modal" @click="$refs.knowledgeBaseModal.knowledgeBase(record)">
          <i class="ti ti-edit"></i>
        </a>
        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.knowledgeBaseModal.knowledgeBase(record)">
          <i class="ti ti-trash"></i>
        </a>
      </div>
    </template>
  </template>
</a-table>

 <div v-else class="p-3 text-center text-muted"> No records found. </div>

</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>

<knowledge-base-modal ref="knowledgeBaseModal" :categories="categories" @updated="knowledgeBases"></knowledge-base-modal>
</template>